import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

/**
 * @note `SvgIcon` 컴포넌트를 사용하지 않음.
 */
export default function SFRefreshIcon({ color = 'white' }: { color?: string }) {
  return (
    // <SvgIcon {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4.71564V9.04894H7.20015"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75706 12.66C5.6895 15.3905 8.25988 17.1557 11.0613 16.9893C13.8627 16.823 16.2198 14.7652 16.8425 11.9424C17.4651 9.11956 16.2032 6.21214 13.7474 4.81152C11.2916 3.41089 8.23397 3.85472 6.24812 5.90007L3 9.04894"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // </SvgIcon>
  );
}
